module.exports = __webpack_public_path__ + "static/img/img2.7b901f22.png";